import { default as indexMKQhsN49vsMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/business/index.vue?macro=true";
import { default as indexnZkKGzcxYdMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/companies/company/index.vue?macro=true";
import { default as indexNMXeNKYBo6Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/companies/index.vue?macro=true";
import { default as indexJ36JGmiSujMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/discounts/index.vue?macro=true";
import { default as indexqSbM9IcNkjMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/favorites/index.vue?macro=true";
import { default as indexwLpcz7n7fOMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/index.vue?macro=true";
import { default as indexiW4xcGsPY2Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/messages/index.vue?macro=true";
import { default as indexxP9vKMU44eMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/nearest-companies/index.vue?macro=true";
import { default as indexIOMc83j1MjMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/posts/index.vue?macro=true";
import { default as indexCzidZP9qYnMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/search/index.vue?macro=true";
import { default as indexWitniHNIKhMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/services/service/index.vue?macro=true";
import { default as indexsiJLelwzoVMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/special-companies/index.vue?macro=true";
import { default as indexqD70q8w8MiMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/special-services/index.vue?macro=true";
import { default as indexYhtvvSkzh1Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/stories/index.vue?macro=true";
import { default as editFZl6LAm4fFMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/edit.vue?macro=true";
import { default as indexJy7ahcDv0sMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/index.vue?macro=true";
import { default as new_45adminxKHd7j6WUuMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/new-admin.vue?macro=true";
import { default as indexzUSRm2GuH3Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/deposits/index.vue?macro=true";
import { default as index5Mww34J1jyMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/index.vue?macro=true";
import { default as indexu42n58UyuGMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/profile/index.vue?macro=true";
import { default as editeDsHDsmfCuMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/users/edit.vue?macro=true";
import { default as indexm5AQu2zwfeMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/users/index.vue?macro=true";
import { default as dashboardIndexfNmNxKOysRMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboardIndex.vue?macro=true";
import { default as indexKIGQQhm9B2Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/index.vue?macro=true";
import { default as mainZefDFtuQjDMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/main.vue?macro=true";
import { default as indexwEegJnk2clMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/my-booking/index.vue?macro=true";
import { default as otpzOy7kYytXGMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/otp.vue?macro=true";
import { default as panel_45login8EeGzqRZuVMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/panel-login.vue?macro=true";
import { default as calendar4JlMhmmqgzMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/calendar.vue?macro=true";
import { default as categoriesFBFDvh8dNVMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/categories.vue?macro=true";
import { default as companiesZNLySOg6CTMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/companies.vue?macro=true";
import { default as contentH9MTUeuRhOMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/content.vue?macro=true";
import { default as default_45serviceshiLrkypGhbMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/default-services.vue?macro=true";
import { default as indexcWNYdOnptcMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/index.vue?macro=true";
import { default as mediaZV2pjKIq4eMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/media.vue?macro=true";
import { default as _91report_931Zub1yr2rcMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/report-details/[report].vue?macro=true";
import { default as _91report_9348cpojjDJIMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/reports/[report].vue?macro=true";
import { default as reports0RgxKjhXTkMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/reports.vue?macro=true";
import { default as update_45initial_45password372i9pj5RrMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/update-initial-password.vue?macro=true";
import { default as business_45access_45deniedFXo4rHOpueMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/business-access-denied.vue?macro=true";
import { default as indexiYus2c8WEHMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-registration/index.vue?macro=true";
import { default as indexqeoLccECWQMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/admin/index.vue?macro=true";
import { default as index3GuuvcuF3AMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/cancel/index.vue?macro=true";
import { default as index9OrrfOmyFHMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/create/index.vue?macro=true";
import { default as index6U5KyjweyKMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/edit/index.vue?macro=true";
import { default as indextWdda7NJjvMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/index.vue?macro=true";
import { default as indexjhRwBsJ6aDMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/search/index.vue?macro=true";
import { default as index7U1IYHkT4MMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/state/index.vue?macro=true";
import { default as indexfLziEedsiMMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/blog/index.vue?macro=true";
import { default as indexnJY3UMZmuXMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/discount/index.vue?macro=true";
import { default as indexwBx4uChEBHMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/index.vue?macro=true";
import { default as indexJKGHDbIXohMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/data/index.vue?macro=true";
import { default as indexvLaAie3kn9Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/index.vue?macro=true";
import { default as indexmSJ96asOtNMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/media/index.vue?macro=true";
import { default as indexHLIgi1kuCBMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/messages/index.vue?macro=true";
import { default as indexM1xuOVYw5CMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reply-comments/index.vue?macro=true";
import { default as _91report_9352gPkxQAQ1Meta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/report-details/[report].vue?macro=true";
import { default as _91report_938n93R8PVnLMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reports/[report].vue?macro=true";
import { default as indexXzPaonSmCbMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reports/index.vue?macro=true";
import { default as indexfgQYpe19kIMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/service/index.vue?macro=true";
import { default as indexzW35abpWSZMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/unit/index.vue?macro=true";
import { default as indexOzlPRpUszvMeta } from "D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/index.vue?macro=true";
export default [
  {
    name: indexMKQhsN49vsMeta?.name ?? "business",
    path: indexMKQhsN49vsMeta?.path ?? "/business",
    meta: indexMKQhsN49vsMeta || {},
    alias: indexMKQhsN49vsMeta?.alias || [],
    redirect: indexMKQhsN49vsMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/business/index.vue").then(m => m.default || m)
  },
  {
    name: indexnZkKGzcxYdMeta?.name ?? "client-page-companies-company",
    path: indexnZkKGzcxYdMeta?.path ?? "/client-page/companies/company",
    meta: indexnZkKGzcxYdMeta || {},
    alias: indexnZkKGzcxYdMeta?.alias || [],
    redirect: indexnZkKGzcxYdMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/companies/company/index.vue").then(m => m.default || m)
  },
  {
    name: indexNMXeNKYBo6Meta?.name ?? "client-page-companies",
    path: indexNMXeNKYBo6Meta?.path ?? "/client-page/companies",
    meta: indexNMXeNKYBo6Meta || {},
    alias: indexNMXeNKYBo6Meta?.alias || [],
    redirect: indexNMXeNKYBo6Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/companies/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ36JGmiSujMeta?.name ?? "client-page-discounts",
    path: indexJ36JGmiSujMeta?.path ?? "/client-page/discounts",
    meta: indexJ36JGmiSujMeta || {},
    alias: indexJ36JGmiSujMeta?.alias || [],
    redirect: indexJ36JGmiSujMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/discounts/index.vue").then(m => m.default || m)
  },
  {
    name: indexqSbM9IcNkjMeta?.name ?? "client-page-favorites",
    path: indexqSbM9IcNkjMeta?.path ?? "/client-page/favorites",
    meta: indexqSbM9IcNkjMeta || {},
    alias: indexqSbM9IcNkjMeta?.alias || [],
    redirect: indexqSbM9IcNkjMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/favorites/index.vue").then(m => m.default || m)
  },
  {
    name: indexwLpcz7n7fOMeta?.name ?? "client-page",
    path: indexwLpcz7n7fOMeta?.path ?? "/client-page",
    meta: indexwLpcz7n7fOMeta || {},
    alias: indexwLpcz7n7fOMeta?.alias || [],
    redirect: indexwLpcz7n7fOMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/index.vue").then(m => m.default || m)
  },
  {
    name: indexiW4xcGsPY2Meta?.name ?? "client-page-messages",
    path: indexiW4xcGsPY2Meta?.path ?? "/client-page/messages",
    meta: indexiW4xcGsPY2Meta || {},
    alias: indexiW4xcGsPY2Meta?.alias || [],
    redirect: indexiW4xcGsPY2Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/messages/index.vue").then(m => m.default || m)
  },
  {
    name: indexxP9vKMU44eMeta?.name ?? "client-page-nearest-companies",
    path: indexxP9vKMU44eMeta?.path ?? "/client-page/nearest-companies",
    meta: indexxP9vKMU44eMeta || {},
    alias: indexxP9vKMU44eMeta?.alias || [],
    redirect: indexxP9vKMU44eMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/nearest-companies/index.vue").then(m => m.default || m)
  },
  {
    name: indexIOMc83j1MjMeta?.name ?? "client-page-posts",
    path: indexIOMc83j1MjMeta?.path ?? "/client-page/posts",
    meta: indexIOMc83j1MjMeta || {},
    alias: indexIOMc83j1MjMeta?.alias || [],
    redirect: indexIOMc83j1MjMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/posts/index.vue").then(m => m.default || m)
  },
  {
    name: indexCzidZP9qYnMeta?.name ?? "client-page-search",
    path: indexCzidZP9qYnMeta?.path ?? "/client-page/search",
    meta: indexCzidZP9qYnMeta || {},
    alias: indexCzidZP9qYnMeta?.alias || [],
    redirect: indexCzidZP9qYnMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexWitniHNIKhMeta?.name ?? "client-page-services-service",
    path: indexWitniHNIKhMeta?.path ?? "/client-page/services/service",
    meta: indexWitniHNIKhMeta || {},
    alias: indexWitniHNIKhMeta?.alias || [],
    redirect: indexWitniHNIKhMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/services/service/index.vue").then(m => m.default || m)
  },
  {
    name: indexsiJLelwzoVMeta?.name ?? "client-page-special-companies",
    path: indexsiJLelwzoVMeta?.path ?? "/client-page/special-companies",
    meta: indexsiJLelwzoVMeta || {},
    alias: indexsiJLelwzoVMeta?.alias || [],
    redirect: indexsiJLelwzoVMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/special-companies/index.vue").then(m => m.default || m)
  },
  {
    name: indexqD70q8w8MiMeta?.name ?? "client-page-special-services",
    path: indexqD70q8w8MiMeta?.path ?? "/client-page/special-services",
    meta: indexqD70q8w8MiMeta || {},
    alias: indexqD70q8w8MiMeta?.alias || [],
    redirect: indexqD70q8w8MiMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/special-services/index.vue").then(m => m.default || m)
  },
  {
    name: indexYhtvvSkzh1Meta?.name ?? "client-page-stories",
    path: indexYhtvvSkzh1Meta?.path ?? "/client-page/stories",
    meta: indexYhtvvSkzh1Meta || {},
    alias: indexYhtvvSkzh1Meta?.alias || [],
    redirect: indexYhtvvSkzh1Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/client-page/stories/index.vue").then(m => m.default || m)
  },
  {
    name: editFZl6LAm4fFMeta?.name ?? "dashboard-admins-edit",
    path: editFZl6LAm4fFMeta?.path ?? "/dashboard/admins/edit",
    meta: editFZl6LAm4fFMeta || {},
    alias: editFZl6LAm4fFMeta?.alias || [],
    redirect: editFZl6LAm4fFMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/edit.vue").then(m => m.default || m)
  },
  {
    name: indexJy7ahcDv0sMeta?.name ?? "dashboard-admins",
    path: indexJy7ahcDv0sMeta?.path ?? "/dashboard/admins",
    meta: indexJy7ahcDv0sMeta || {},
    alias: indexJy7ahcDv0sMeta?.alias || [],
    redirect: indexJy7ahcDv0sMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/index.vue").then(m => m.default || m)
  },
  {
    name: new_45adminxKHd7j6WUuMeta?.name ?? "dashboard-admins-new-admin",
    path: new_45adminxKHd7j6WUuMeta?.path ?? "/dashboard/admins/new-admin",
    meta: new_45adminxKHd7j6WUuMeta || {},
    alias: new_45adminxKHd7j6WUuMeta?.alias || [],
    redirect: new_45adminxKHd7j6WUuMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/admins/new-admin.vue").then(m => m.default || m)
  },
  {
    name: indexzUSRm2GuH3Meta?.name ?? "dashboard-deposits",
    path: indexzUSRm2GuH3Meta?.path ?? "/dashboard/deposits",
    meta: indexzUSRm2GuH3Meta || {},
    alias: indexzUSRm2GuH3Meta?.alias || [],
    redirect: indexzUSRm2GuH3Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/deposits/index.vue").then(m => m.default || m)
  },
  {
    name: index5Mww34J1jyMeta?.name ?? "dashboard",
    path: index5Mww34J1jyMeta?.path ?? "/dashboard",
    meta: index5Mww34J1jyMeta || {},
    alias: index5Mww34J1jyMeta?.alias || [],
    redirect: index5Mww34J1jyMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: indexu42n58UyuGMeta?.name ?? "dashboard-profile",
    path: indexu42n58UyuGMeta?.path ?? "/dashboard/profile",
    meta: indexu42n58UyuGMeta || {},
    alias: indexu42n58UyuGMeta?.alias || [],
    redirect: indexu42n58UyuGMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/profile/index.vue").then(m => m.default || m)
  },
  {
    name: editeDsHDsmfCuMeta?.name ?? "dashboard-users-edit",
    path: editeDsHDsmfCuMeta?.path ?? "/dashboard/users/edit",
    meta: editeDsHDsmfCuMeta || {},
    alias: editeDsHDsmfCuMeta?.alias || [],
    redirect: editeDsHDsmfCuMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/users/edit.vue").then(m => m.default || m)
  },
  {
    name: indexm5AQu2zwfeMeta?.name ?? "dashboard-users",
    path: indexm5AQu2zwfeMeta?.path ?? "/dashboard/users",
    meta: indexm5AQu2zwfeMeta || {},
    alias: indexm5AQu2zwfeMeta?.alias || [],
    redirect: indexm5AQu2zwfeMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboard/users/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardIndexfNmNxKOysRMeta?.name ?? "dashboardIndex",
    path: dashboardIndexfNmNxKOysRMeta?.path ?? "/dashboardIndex",
    meta: dashboardIndexfNmNxKOysRMeta || {},
    alias: dashboardIndexfNmNxKOysRMeta?.alias || [],
    redirect: dashboardIndexfNmNxKOysRMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/dashboardIndex.vue").then(m => m.default || m)
  },
  {
    name: indexKIGQQhm9B2Meta?.name ?? "index",
    path: indexKIGQQhm9B2Meta?.path ?? "/",
    meta: indexKIGQQhm9B2Meta || {},
    alias: indexKIGQQhm9B2Meta?.alias || [],
    redirect: indexKIGQQhm9B2Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: mainZefDFtuQjDMeta?.name ?? "main",
    path: mainZefDFtuQjDMeta?.path ?? "/main",
    meta: mainZefDFtuQjDMeta || {},
    alias: mainZefDFtuQjDMeta?.alias || [],
    redirect: mainZefDFtuQjDMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/main.vue").then(m => m.default || m)
  },
  {
    name: indexwEegJnk2clMeta?.name ?? "my-booking",
    path: indexwEegJnk2clMeta?.path ?? "/my-booking",
    meta: indexwEegJnk2clMeta || {},
    alias: indexwEegJnk2clMeta?.alias || [],
    redirect: indexwEegJnk2clMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/my-booking/index.vue").then(m => m.default || m)
  },
  {
    name: otpzOy7kYytXGMeta?.name ?? "otp",
    path: otpzOy7kYytXGMeta?.path ?? "/otp",
    meta: otpzOy7kYytXGMeta || {},
    alias: otpzOy7kYytXGMeta?.alias || [],
    redirect: otpzOy7kYytXGMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/otp.vue").then(m => m.default || m)
  },
  {
    name: panel_45login8EeGzqRZuVMeta?.name ?? "panel-login",
    path: panel_45login8EeGzqRZuVMeta?.path ?? "/panel-login",
    meta: panel_45login8EeGzqRZuVMeta || {},
    alias: panel_45login8EeGzqRZuVMeta?.alias || [],
    redirect: panel_45login8EeGzqRZuVMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/panel-login.vue").then(m => m.default || m)
  },
  {
    name: calendar4JlMhmmqgzMeta?.name ?? "support-calendar",
    path: calendar4JlMhmmqgzMeta?.path ?? "/support/calendar",
    meta: calendar4JlMhmmqgzMeta || {},
    alias: calendar4JlMhmmqgzMeta?.alias || [],
    redirect: calendar4JlMhmmqgzMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/calendar.vue").then(m => m.default || m)
  },
  {
    name: categoriesFBFDvh8dNVMeta?.name ?? "support-categories",
    path: categoriesFBFDvh8dNVMeta?.path ?? "/support/categories",
    meta: categoriesFBFDvh8dNVMeta || {},
    alias: categoriesFBFDvh8dNVMeta?.alias || [],
    redirect: categoriesFBFDvh8dNVMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/categories.vue").then(m => m.default || m)
  },
  {
    name: companiesZNLySOg6CTMeta?.name ?? "support-companies",
    path: companiesZNLySOg6CTMeta?.path ?? "/support/companies",
    meta: companiesZNLySOg6CTMeta || {},
    alias: companiesZNLySOg6CTMeta?.alias || [],
    redirect: companiesZNLySOg6CTMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/companies.vue").then(m => m.default || m)
  },
  {
    name: contentH9MTUeuRhOMeta?.name ?? "support-content",
    path: contentH9MTUeuRhOMeta?.path ?? "/support/content",
    meta: contentH9MTUeuRhOMeta || {},
    alias: contentH9MTUeuRhOMeta?.alias || [],
    redirect: contentH9MTUeuRhOMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/content.vue").then(m => m.default || m)
  },
  {
    name: default_45serviceshiLrkypGhbMeta?.name ?? "support-default-services",
    path: default_45serviceshiLrkypGhbMeta?.path ?? "/support/default-services",
    meta: default_45serviceshiLrkypGhbMeta || {},
    alias: default_45serviceshiLrkypGhbMeta?.alias || [],
    redirect: default_45serviceshiLrkypGhbMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/default-services.vue").then(m => m.default || m)
  },
  {
    name: indexcWNYdOnptcMeta?.name ?? "support",
    path: indexcWNYdOnptcMeta?.path ?? "/support",
    meta: indexcWNYdOnptcMeta || {},
    alias: indexcWNYdOnptcMeta?.alias || [],
    redirect: indexcWNYdOnptcMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/index.vue").then(m => m.default || m)
  },
  {
    name: mediaZV2pjKIq4eMeta?.name ?? "support-media",
    path: mediaZV2pjKIq4eMeta?.path ?? "/support/media",
    meta: mediaZV2pjKIq4eMeta || {},
    alias: mediaZV2pjKIq4eMeta?.alias || [],
    redirect: mediaZV2pjKIq4eMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/media.vue").then(m => m.default || m)
  },
  {
    name: _91report_931Zub1yr2rcMeta?.name ?? "support-report-details-report",
    path: _91report_931Zub1yr2rcMeta?.path ?? "/support/report-details/:report()",
    meta: _91report_931Zub1yr2rcMeta || {},
    alias: _91report_931Zub1yr2rcMeta?.alias || [],
    redirect: _91report_931Zub1yr2rcMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/report-details/[report].vue").then(m => m.default || m)
  },
  {
    name: reports0RgxKjhXTkMeta?.name ?? "support-reports",
    path: reports0RgxKjhXTkMeta?.path ?? "/support/reports",
    children: [
  {
    name: _91report_9348cpojjDJIMeta?.name ?? "support-reports-report",
    path: _91report_9348cpojjDJIMeta?.path ?? ":report()",
    meta: _91report_9348cpojjDJIMeta || {},
    alias: _91report_9348cpojjDJIMeta?.alias || [],
    redirect: _91report_9348cpojjDJIMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/reports/[report].vue").then(m => m.default || m)
  }
],
    meta: reports0RgxKjhXTkMeta || {},
    alias: reports0RgxKjhXTkMeta?.alias || [],
    redirect: reports0RgxKjhXTkMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/support/reports.vue").then(m => m.default || m)
  },
  {
    name: update_45initial_45password372i9pj5RrMeta?.name ?? "update-initial-password",
    path: update_45initial_45password372i9pj5RrMeta?.path ?? "/update-initial-password",
    meta: update_45initial_45password372i9pj5RrMeta || {},
    alias: update_45initial_45password372i9pj5RrMeta?.alias || [],
    redirect: update_45initial_45password372i9pj5RrMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/update-initial-password.vue").then(m => m.default || m)
  },
  {
    name: business_45access_45deniedFXo4rHOpueMeta?.name ?? "user-profile-business-access-denied",
    path: business_45access_45deniedFXo4rHOpueMeta?.path ?? "/user-profile/business-access-denied",
    meta: business_45access_45deniedFXo4rHOpueMeta || {},
    alias: business_45access_45deniedFXo4rHOpueMeta?.alias || [],
    redirect: business_45access_45deniedFXo4rHOpueMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/business-access-denied.vue").then(m => m.default || m)
  },
  {
    name: indexiYus2c8WEHMeta?.name ?? "user-profile-company-registration",
    path: indexiYus2c8WEHMeta?.path ?? "/user-profile/company-registration",
    meta: indexiYus2c8WEHMeta || {},
    alias: indexiYus2c8WEHMeta?.alias || [],
    redirect: indexiYus2c8WEHMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-registration/index.vue").then(m => m.default || m)
  },
  {
    name: indexqeoLccECWQMeta?.name ?? "user-profile-company-settings-admin",
    path: indexqeoLccECWQMeta?.path ?? "/user-profile/company-settings/admin",
    meta: indexqeoLccECWQMeta || {},
    alias: indexqeoLccECWQMeta?.alias || [],
    redirect: indexqeoLccECWQMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/admin/index.vue").then(m => m.default || m)
  },
  {
    name: index3GuuvcuF3AMeta?.name ?? "user-profile-company-settings-appointment-cancel",
    path: index3GuuvcuF3AMeta?.path ?? "/user-profile/company-settings/appointment/cancel",
    meta: index3GuuvcuF3AMeta || {},
    alias: index3GuuvcuF3AMeta?.alias || [],
    redirect: index3GuuvcuF3AMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/cancel/index.vue").then(m => m.default || m)
  },
  {
    name: index9OrrfOmyFHMeta?.name ?? "user-profile-company-settings-appointment-create",
    path: index9OrrfOmyFHMeta?.path ?? "/user-profile/company-settings/appointment/create",
    meta: index9OrrfOmyFHMeta || {},
    alias: index9OrrfOmyFHMeta?.alias || [],
    redirect: index9OrrfOmyFHMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/create/index.vue").then(m => m.default || m)
  },
  {
    name: index6U5KyjweyKMeta?.name ?? "user-profile-company-settings-appointment-edit",
    path: index6U5KyjweyKMeta?.path ?? "/user-profile/company-settings/appointment/edit",
    meta: index6U5KyjweyKMeta || {},
    alias: index6U5KyjweyKMeta?.alias || [],
    redirect: index6U5KyjweyKMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/edit/index.vue").then(m => m.default || m)
  },
  {
    name: indextWdda7NJjvMeta?.name ?? "user-profile-company-settings-appointment",
    path: indextWdda7NJjvMeta?.path ?? "/user-profile/company-settings/appointment",
    meta: indextWdda7NJjvMeta || {},
    alias: indextWdda7NJjvMeta?.alias || [],
    redirect: indextWdda7NJjvMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/index.vue").then(m => m.default || m)
  },
  {
    name: indexjhRwBsJ6aDMeta?.name ?? "user-profile-company-settings-appointment-search",
    path: indexjhRwBsJ6aDMeta?.path ?? "/user-profile/company-settings/appointment/search",
    meta: indexjhRwBsJ6aDMeta || {},
    alias: indexjhRwBsJ6aDMeta?.alias || [],
    redirect: indexjhRwBsJ6aDMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/search/index.vue").then(m => m.default || m)
  },
  {
    name: index7U1IYHkT4MMeta?.name ?? "user-profile-company-settings-appointment-state",
    path: index7U1IYHkT4MMeta?.path ?? "/user-profile/company-settings/appointment/state",
    meta: index7U1IYHkT4MMeta || {},
    alias: index7U1IYHkT4MMeta?.alias || [],
    redirect: index7U1IYHkT4MMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/appointment/state/index.vue").then(m => m.default || m)
  },
  {
    name: indexfLziEedsiMMeta?.name ?? "user-profile-company-settings-blog",
    path: indexfLziEedsiMMeta?.path ?? "/user-profile/company-settings/blog",
    meta: indexfLziEedsiMMeta || {},
    alias: indexfLziEedsiMMeta?.alias || [],
    redirect: indexfLziEedsiMMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexnJY3UMZmuXMeta?.name ?? "user-profile-company-settings-discount",
    path: indexnJY3UMZmuXMeta?.path ?? "/user-profile/company-settings/discount",
    meta: indexnJY3UMZmuXMeta || {},
    alias: indexnJY3UMZmuXMeta?.alias || [],
    redirect: indexnJY3UMZmuXMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/discount/index.vue").then(m => m.default || m)
  },
  {
    name: indexwBx4uChEBHMeta?.name ?? "user-profile-company-settings",
    path: indexwBx4uChEBHMeta?.path ?? "/user-profile/company-settings",
    meta: indexwBx4uChEBHMeta || {},
    alias: indexwBx4uChEBHMeta?.alias || [],
    redirect: indexwBx4uChEBHMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/index.vue").then(m => m.default || m)
  },
  {
    name: indexJKGHDbIXohMeta?.name ?? "user-profile-company-settings-information-data",
    path: indexJKGHDbIXohMeta?.path ?? "/user-profile/company-settings/information/data",
    meta: indexJKGHDbIXohMeta || {},
    alias: indexJKGHDbIXohMeta?.alias || [],
    redirect: indexJKGHDbIXohMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/data/index.vue").then(m => m.default || m)
  },
  {
    name: indexvLaAie3kn9Meta?.name ?? "user-profile-company-settings-information",
    path: indexvLaAie3kn9Meta?.path ?? "/user-profile/company-settings/information",
    meta: indexvLaAie3kn9Meta || {},
    alias: indexvLaAie3kn9Meta?.alias || [],
    redirect: indexvLaAie3kn9Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/index.vue").then(m => m.default || m)
  },
  {
    name: indexmSJ96asOtNMeta?.name ?? "user-profile-company-settings-information-media",
    path: indexmSJ96asOtNMeta?.path ?? "/user-profile/company-settings/information/media",
    meta: indexmSJ96asOtNMeta || {},
    alias: indexmSJ96asOtNMeta?.alias || [],
    redirect: indexmSJ96asOtNMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/information/media/index.vue").then(m => m.default || m)
  },
  {
    name: indexHLIgi1kuCBMeta?.name ?? "user-profile-company-settings-messages",
    path: indexHLIgi1kuCBMeta?.path ?? "/user-profile/company-settings/messages",
    meta: indexHLIgi1kuCBMeta || {},
    alias: indexHLIgi1kuCBMeta?.alias || [],
    redirect: indexHLIgi1kuCBMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/messages/index.vue").then(m => m.default || m)
  },
  {
    name: indexM1xuOVYw5CMeta?.name ?? "user-profile-company-settings-reply-comments",
    path: indexM1xuOVYw5CMeta?.path ?? "/user-profile/company-settings/reply-comments",
    meta: indexM1xuOVYw5CMeta || {},
    alias: indexM1xuOVYw5CMeta?.alias || [],
    redirect: indexM1xuOVYw5CMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reply-comments/index.vue").then(m => m.default || m)
  },
  {
    name: _91report_9352gPkxQAQ1Meta?.name ?? "user-profile-company-settings-report-details-report",
    path: _91report_9352gPkxQAQ1Meta?.path ?? "/user-profile/company-settings/report-details/:report()",
    meta: _91report_9352gPkxQAQ1Meta || {},
    alias: _91report_9352gPkxQAQ1Meta?.alias || [],
    redirect: _91report_9352gPkxQAQ1Meta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/report-details/[report].vue").then(m => m.default || m)
  },
  {
    name: _91report_938n93R8PVnLMeta?.name ?? "user-profile-company-settings-reports-report",
    path: _91report_938n93R8PVnLMeta?.path ?? "/user-profile/company-settings/reports/:report()",
    meta: _91report_938n93R8PVnLMeta || {},
    alias: _91report_938n93R8PVnLMeta?.alias || [],
    redirect: _91report_938n93R8PVnLMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reports/[report].vue").then(m => m.default || m)
  },
  {
    name: indexXzPaonSmCbMeta?.name ?? "user-profile-company-settings-reports",
    path: indexXzPaonSmCbMeta?.path ?? "/user-profile/company-settings/reports",
    meta: indexXzPaonSmCbMeta || {},
    alias: indexXzPaonSmCbMeta?.alias || [],
    redirect: indexXzPaonSmCbMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/reports/index.vue").then(m => m.default || m)
  },
  {
    name: indexfgQYpe19kIMeta?.name ?? "user-profile-company-settings-service",
    path: indexfgQYpe19kIMeta?.path ?? "/user-profile/company-settings/service",
    meta: indexfgQYpe19kIMeta || {},
    alias: indexfgQYpe19kIMeta?.alias || [],
    redirect: indexfgQYpe19kIMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/service/index.vue").then(m => m.default || m)
  },
  {
    name: indexzW35abpWSZMeta?.name ?? "user-profile-company-settings-unit",
    path: indexzW35abpWSZMeta?.path ?? "/user-profile/company-settings/unit",
    meta: indexzW35abpWSZMeta || {},
    alias: indexzW35abpWSZMeta?.alias || [],
    redirect: indexzW35abpWSZMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/company-settings/unit/index.vue").then(m => m.default || m)
  },
  {
    name: indexOzlPRpUszvMeta?.name ?? "user-profile",
    path: indexOzlPRpUszvMeta?.path ?? "/user-profile",
    meta: indexOzlPRpUszvMeta || {},
    alias: indexOzlPRpUszvMeta?.alias || [],
    redirect: indexOzlPRpUszvMeta?.redirect || undefined,
    component: () => import("D:/Projects/Alomonshi/AlomonshiCode/AlomonshiFront/src/pages/user-profile/index.vue").then(m => m.default || m)
  }
]